import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { ToursProvider } from './components/ToursSection';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import ToursSection from './components/ToursSection';
import DestinationsSection from './components/DestinationsSection';
import TestimonialsSection from './components/TestimonialsSection';
import VillasSection from './components/VillasSection';
import ContactSection from './components/ContactSection';
import { Footer, WhatsAppButton } from './components/Footer';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import TourDetail from './pages/TourDetail';

const HomePage = () => {
  return (
    <>
      <Header />
      <main>
        <section id="inicio">
          <HeroSection />
        </section>
        <IntroSection />
        <ToursSection />
        <DestinationsSection />
        <TestimonialsSection />
        <VillasSection />
        <section id="contacto">
          <ContactSection />
        </section>
      </main>
      <Footer />
      <WhatsAppButton />
    </>
  );
};

function App() {
  return (
    <LanguageProvider>
      <ToursProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/tour/:id" element={<TourDetail />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
            </Routes>
          </BrowserRouter>
        </div>
      </ToursProvider>
    </LanguageProvider>
  );
}

export default App;
